module.exports = "http://localhost:4567/assets/fonts/fee66e712a8a08eef5805a46892932ad.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0
// module id = 799
// module chunks = 4